module.exports = __webpack_public_path__ + "static/media/solutionpage-3.1cc3bdac.png";